import { BoxProps } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import clientApi from '~/clientApi';
import { YT_CHANNEL_ENTITY_QUERY_KEY } from '~/queries/keys';
import { selectCreator } from '~/selectors/creator';
import { CreatorBenchmarks, DefaultMediaPackType } from '~/types';

import { AverageMetrics } from './AverageMetrics';

interface Props extends BoxProps {
  mediaPack: DefaultMediaPackType;
  creatorBenchmarks: CreatorBenchmarks;
}

export const AverageMetricsContainer: React.FC<Props> = ({ ...props }) => {
  const creator = useSelector(selectCreator);
  const router = useRouter();
  const { sharedToken } = router.query;

  const queryParams = sharedToken
    ? {
        _sharedToken: sharedToken,
      }
    : { _impersonateOnce: creator?.id };

  const { data: ytChannel = {} } = useQuery(
    [YT_CHANNEL_ENTITY_QUERY_KEY],
    () =>
      clientApi.ytChannel.read({
        id: creator?.ytChannels?.[0]?.id,
        ...queryParams,
      }),
    {
      enabled: Boolean(creator?.ytChannels?.length),
    },
  );

  return <AverageMetrics {...props} ytChannel={ytChannel} />;
};
